export const GLOSSARY = [
    {
       "key":1,
       "value":"access control lists (ACLs)",
       "description":"Lists used to match IP or Media Access Control (MAC) addresses for access control, route filtering, network address translation, traffic classification, and conditional debugs. Always contain an implicit deny at the end."
    },
    {
       "key":2,
       "value":"access-distribution block",
       "description":"Composed of the distribution and access layers, it\u0027s a building block that can be plugged into the core, allowing the network to be expanded in a modular fashion."
    },
    {
       "key":3,
       "value":"accounting",
       "description":"Keeps track of what commands users run when logged into a Cisco device."
    },
    {
       "key":4,
       "value":"anycast gateway",
       "description":"The configuration that describes when multiple fabric edge nodes, functioning as a gateway, share the same Media Access Control (MAC) address and IP address."
    },
    {
       "key":5,
       "value":"application programming interfaces (APIs)",
       "description":"An interface that allows interaction with an application using a well-defined set of protocols and functions. Some common APIs used in networking are NETCONF, RESTCONF, and the Cisco DNA Center Intent API."
    },
    {
       "key":6,
       "value":"area border router (ABR)",
       "description":"A router that has Open Shortest Path First (OSPF) interfaces in two or more areas."
    },
    {
       "key":7,
       "value":"authentication",
       "description":"The process of establishing the identity of a user or machine."
    },
    {
       "key":8,
       "value":"authorization",
       "description":"The process of determining what actions a user is allowed to perform or what resources they are allowed to access."
    },
    {
       "key":9,
       "value":"autonomous system boundary router (ASBR)",
       "description":"An Open Shortest Path First (OSPF) router that redistributes routes between OSPF and another routing protocol, such as Enhanced Interior Gateway Routing Protocol (EIGRP) or Border Gateway Protocol (BGP). An ASBR may also redistribute static or connected routes."
    },
    {
       "key":10,
       "value":"class map",
       "description":"Classifies packets according to a variety of criteria, such IP address, protocol, port number, source Media Access Control (MAC) address, packet length, Differentiated Service Code Point (DSCP) value, or 802.1Q class of service (CoS) value."
    },
    {
       "key":11,
       "value":"class of service (CoS)",
       "description":"A 3-bit field defined by IEEE 802.1Q that can you may use to assign one of eight priority code points (PCPs) for quality of service (QoS) classification. Sometimes called the 802.1p field or PCP field."
    },
    {
       "key":12,
       "value":"Class-Based Weighted Fair Queuing (CBWFQ)",
       "description":"A queuing algorithm that creates up to 256 queues for 256 different traffic classes. Good for TCP-based applications that adapt to bandwidth constraints and packet drops, but not good for delay-sensitive traffic such as voice."
    },
    {
       "key":13,
       "value":"class-default",
       "description":"The name of the default class map that matches all packets."
    },
    {
       "key":14,
       "value":"classification",
       "description":"Identifying packets according to how you want routers to treat them during times of congestion."
    },
    {
       "key":15,
       "value":"committed burst",
       "description":"The number of bytes that can be covered using tokens in the Bc bucket. committed information rate (CIR) The rate within which packets are conforming. Packets beyond the CIR are said to be exceeding."
    },
    {
       "key":16,
       "value":"control plane policing (CoPP)",
       "description":"A mechanism to rate-limit control plane traffic ingressing or egressing a router or switch. Control plane traffic refers to traffic either generated or terminated by the device itself, as opposed to data plane traffic that flows through it."
    },
    {
       "key":17,
       "value":"designated router (DR)",
       "description":"An Open Shortest Path First (OSPF) router that collects Type 1 link-state advertisements (LSAs) from other OSPF routers on the broadcast segment and combines them into a Type 2 Network LSA that describes all the routers on the segment. It then sends the Type 2 Network LSA to its OSPF neighbors."
    },
    {
       "key":18,
       "value":"diffusing update algorithm (DR)",
       "description":"The algorithm Enhanced Interior Gateway Routing Protocol (EIGRP) uses to find the shortest path to a destination without creating a routing loop."
    },
    {
       "key":19,
       "value":"dynamic NAT",
       "description":"A temporary, one-to-one mapping of an inside local to an inside global address."
    },
    {
       "key":20,
       "value":"EAP chaining",
       "description":"A form of Extensible Authentication Protocol (EAP) that allows simultaneous authentication of both the user and the machine."
    },
    {
       "key":21,
       "value":"East-West",
       "description":"Another term for server-to-server traffic, such as migrating a virtual machine from one host to another."
    },
    {
       "key":22,
       "value":"egress tunnel router (ETR)",
       "description":"A Lisp router that decapsulates Lisp packets received from an ingress tunnel router (ITR) and sends the inner packet along to the endpoint ID (EID)."
    },
    {
       "key":23,
       "value":"Embedded Event Manager (EEM)",
       "description":"An on-device automation tool that uses the Tcl scripting language."
    },
    {
       "key":24,
       "value":"Encapsulating Security Payload (ESP)",
       "description":"Provides encryption and authentication for IPsec. Uses IP protocol 50."
    },
    {
       "key":25,
       "value":"endpoint IDs (EID)",
       "description":"IP prefixes that a Lisp ingress tunnel router (ITR) or egress tunnel router (ETR) can reach."
    },
    {
       "key":26,
       "value":"equal cost multipathing (ECMP)",
       "description":"Simultaneously using multiple equal paths to increase available bandwidth."
    },
    {
       "key":27,
       "value":"excess burst",
       "description":"The number of bytes that can be covered using tokens in the Be bucket."
    },
    {
       "key":28,
       "value":"explicit congestion notification (ECN)",
       "description":"Notifies a TCP sender of congestion so that it will slow down the rate at which it sends by reducing its congestion window."
    },
    {
       "key":29,
       "value":"fair queuing",
       "description":"Creates a dynamic number of queues for different classes of traffic."
    },
    {
       "key":30,
       "value":"feasibility condition",
       "description":"Is said to be met if the advertised distance is less than the feasible distance. Its purpose is to ensure that the feasible successor offers a loop-free path to the destination in case the best path becomes unavailable."
    },
    {
       "key":31,
       "value":"feasible distance",
       "description":"In Enhanced Interior Gateway Routing Protocol (EIGRP), the path with the lowest cost."
    },
    {
       "key":32,
       "value":"feasible successor",
       "description":"An Enhanced Interior Gateway Routing Protocol (EIGRP)route that meets the feasibility condition."
    },
    {
       "key":33,
       "value":"first-in, first-out (FIFO)",
       "description":"queuing An algorithm in which packets are queued up in the order they\u0027re received."
    },
    {
       "key":34,
       "value":"frequency-shift keying (FSK)",
       "description":"Frequency modulation (FM) used with digital data."
    },
    {
       "key":35,
       "value":"global address",
       "description":"In network address translation (NAT), an address reachable from both inside and outside networks."
    },
    {
       "key":36,
       "value":"hypervisor",
       "description":"A software program called that creates virtual machines. Also called a virtual machine monitor (VMM)."
    },
    {
       "key":37,
       "value":"IGMP snooping",
       "description":"A feature wherein a switch will sniff Internet Group Management Protocol (IGMP Membership Reports to determine which ports multicast group traffic should be forwarded out of. Cisco switches have IGMP snooping enabled by default."
    },
    {
       "key":38,
       "value":"ingress tunnel router (ITR)",
       "description":"A Lisp router that receives a packet from an endpoint ID (EID), encapsulates it in a Lisp packet, and sends it addressed to an egress tunnel router (ETR)\u0027s routing locator (RLOC)."
    },
    {
       "key":39,
       "value":"inside network",
       "description":"In network address translation (NAT), the network under your control."
    },
    {
       "key":40,
       "value":"intercontroller roam",
       "description":"When a client roams between APs that are connected to different wireless LAN controllers."
    },
    {
       "key":41,
       "value":"Internet Key Exchange",
       "description":"The protocol IPsec peers use to exchange encryption keys that they\u0027ll use to encrypt IPsec traffic."
    },
    {
       "key":42,
       "value":"intracontroller roam",
       "description":"When a client roams between APs that are connected to the same wireless LAN controllers."
    },
    {
       "key":43,
       "value":"IP Security (IPsec)",
       "description":"A protocol used to provide encryption, data integrity, and authentication between endpoints."
    },
    {
       "key":44,
       "value":"IP Service Level Agreement",
       "description":"A feature that allows you to monitor network performance and reachability and take some action based on the results."
    },
    {
       "key":45,
       "value":"LAN multicast",
       "description":"A one-to-many forwarding paradigm in which a frame is forwarded to many, but not necessarily all, hosts in a subnet."
    },
    {
       "key":46,
       "value":"law of 10s",
       "description":"A decibel law that states that every 10 dB indicates a tenfold difference between the numbers being compared."
    },
    {
       "key":47,
       "value":"law of 3s",
       "description":"A decibel law that states that every 3-dB difference indicates a twofold difference in the numbers being compared."
    },
    {
       "key":48,
       "value":"law of zeros",
       "description":"A decibel law that states that two signals with 0 dB difference have the same strength."
    },
    {
       "key":49,
       "value":"leaf-and-spine architecture",
       "description":"A popular design in data center networks because it provides a predictable number of hops between any two servers."
    },
    {
       "key":50,
       "value":"link-state advertisements (LSAs)",
       "description":"An Open Shortest Path First (OSPF) advertisement that contains a link-state ID and advertising router ID (RID)."
    },
    {
       "key":51,
       "value":"link-state database (LSDB)",
       "description":"An Open Shortest Path First (OSPF) router-local database that consists of link-state advertisements (LSAs) from an area. Used to form a map of the network against which the router executes the shortest path first (SPF) algorithm."
    },
    {
       "key":52,
       "value":"local address",
       "description":"In network address translation (NAT), an address reachable only from the inside network."
    },
    {
       "key":53,
       "value":"low-latency queue (LLQ)",
       "description":"A strict priority queue that is given reserved bandwidth and always serviced first. It\u0027s limited to the reserved bandwidth during times of congestion."
    },
    {
       "key":54,
       "value":"MAC authentication bypass (MAB)",
       "description":"Authentication of an endpoint using the endpoint\u0027s Media Access Control (MAC) address as its identity."
    },
    {
       "key":55,
       "value":"MAC Security (MACsec)",
       "description":"A layer 2 authentication and encryption scheme that encrypts Ethernet frames between two devices connected directly at the link layer."
    },
    {
       "key":56,
       "value":"MACsec Key Agreement (MKA)",
       "description":"A protocol to negotiate encryption between Cisco and non-Cisco switches."
    },
    {
       "key":57,
       "value":"map resolver",
       "description":"A server that resolves endpoint IDs (EIDs) to routing locators (RLOCs) for Lisp."
    },
    {
       "key":58,
       "value":"map server",
       "description":"A server that receives endpoint ID (EID)-to-routing locator (RLOC) mappings for Lisp."
    },
    {
       "key":59,
       "value":"member port",
       "description":"A port that\u0027s a member of an EtherChannel. to-one communication."
    },
    {
       "key":60,
       "value":"multicast",
       "description":"One-to-many communication, in contrast with unicast, which describes one-to-one communication."
    },
    {
       "key":61,
       "value":"NetFlow",
       "description":"Collects IP flow information and captures the packet or byte count associated with each flow."
    },
    {
       "key":62,
       "value":"network address translation (NAT)",
       "description":"A mechanism to hide multiple private IP addresses behind one public IP address. Originally specified in RFC 1931."
    },
    {
       "key":63,
       "value":"Network Configuration Protocol (NETCONF)",
       "description":"Provides a standardized API for configuring and retrieving configuration and state information from network devices."
    },
    {
       "key":64,
       "value":"Network Time Protocol (NTP)",
       "description":"Protocol that synchronizes time from an NTP master. Uses UDP port 123."
    },
    {
       "key":65,
       "value":"noise",
       "description":"A collection of random intertwined signals present in a receiver\u0027s environment."
    },
    {
       "key":66,
       "value":"noise floor",
       "description":"The sum of all uninteresting signals from other stations, electrical wires, lightning, and even the sun. For a receiver to make out a signal, the received signal strength indicator (RSSI) must be greater than the noise floor."
    },
    {
       "key":67,
       "value":"non-stop forwarding (NSF)",
       "description":"A process that allows IP forwarding to continue without interruption during a stateful switchover."
    },
    {
       "key":68,
       "value":"North-South",
       "description":"Another term for client-to-server traffic."
    },
    {
       "key":69,
       "value":"outside network",
       "description":"In network address translation (NAT), the network outside of your control, where you have no power to change IP addresses."
    },
    {
       "key":70,
       "value":"outside static NAT",
       "description":"Translating an inside local destination IP address of a packet to an outside global address."
    },
    {
       "key":71,
       "value":"peak information rate",
       "description":"The rate within which packets are exceeding but not violating."
    },
    {
       "key":72,
       "value":"phase-shift keying (PSK)",
       "description":"Used as a fallback wireless modulation mechanism in environments with radio interference. Can\u0027t support throughput rates much above 18 Mbps."
    },
    {
       "key":73,
       "value":"policing",
       "description":"A tool that avoids congestion by rate-limiting (dropping) packets before congestion occurs."
    },
    {
       "key":74,
       "value":"policy maps",
       "description":"Applied to interfaces and apply to either inbound or outbound traffic. Used for marking packets and performing policing, shaping, and queuing."
    },
    {
       "key":75,
       "value":"pooled NAT",
       "description":"Another term for dynamic network address translation (NAT). port ACL An access-control list (ACL) applied to a switchport."
    },
    {
       "key":76,
       "value":"port address translation (PAT)",
       "description":"Translates multiple inside local source addresses to a single global address."
    },
    {
       "key":77,
       "value":"port channel group",
       "description":"A group of ports combined into a single port channel interface."
    },
    {
       "key":78,
       "value":"protected EAP (PEAP)",
       "description":"An authentication method that forms a TLS tunnel between the client and the RADIUS server over which the client sends its credentials."
    },
    {
       "key":79,
       "value":"Protocol Independent Multicast (PIM)",
       "description":"A multicast routing protocol that builds the multicast IP routing table for each router."
    },
    {
       "key":80,
       "value":"routing locator (RLOC)",
       "description":"An Internet-reachable IP address of a Lisp ingress tunnel router or egress tunnel router."
    },
    {
       "key":81,
       "value":"scalable group tags (SGT)",
       "description":"A tag in the VXLAN-GPO header that is used to apply security and quality of service (QoS) policies to a virtual network. SGTs are applied at ingress. Also called a Group Policy ID."
    },
    {
       "key":82,
       "value":"Security Association Protocol",
       "description":"A MACsec protocol that negotiates encryption between Cisco switches."
    },
    {
       "key":83,
       "value":"Security Group Exchange Protocol (SXP)",
       "description":"A protocol that exchanges IP-to-SGT mappings. Designed to preserve scalable group tags (SGT) in transit networks that don\u0027t support them."
    },
    {
       "key":84,
       "value":"shaping",
       "description":"Intentionally delaying/queuing packets to avoid dropping them. Often performed by edge routers that are connected to a service provider that offers transport at a lower speed than the access rate"
    },
    {
       "key":85,
       "value":"shortest-path tree (SPT)",
       "description":"The collection of routers between the source and destination subnets for a multicast group."
    },
    {
       "key":86,
       "value":"signal-to-noise ratio (SNR)",
       "description":"The difference between the received signal strength indicator (RSSI) and the noise floor."
    },
    {
       "key":87,
       "value":"Simple Network Management Protocol (SNMP)",
       "description":"A network monitoring protocol that sends traps containing event or device information, such as routing protocol changes, link failures, device access, reboots, and so on. Also supports polling, allowing a monitoring host to request specific device information."
    },
    {
       "key":88,
       "value":"source filtering",
       "description":"A multicast feature giving a receiver the ability to request multicast traffic from a specific source."
    },
    {
       "key":89,
       "value":"Static NAT",
       "description":"Translating between one inside local address and one inside global address. stuck-in-active (SIA) Occurs when the Active timer expires before an Enhanced Interior"
    },
    {
       "key":90,
       "value":"Gateway Routing Protocol (EIGRP)",
       "description":"router receives a Reply to its Query."
    },
    {
       "key":91,
       "value":"Switched Port Analyzer (SPAN)",
       "description":"Allows switches to copy traffic from one port or VLAN and mirror it to a different port."
    },
    {
       "key":92,
       "value":"Syslog",
       "description":"A protocol that decouples the logs that a device generates from the device itself. Enables consolidating logs from multiple devices by sending them into a single server for storage and analysis."
    },
    {
       "key":93,
       "value":"tail-drop",
       "description":"When a queue becomes full, excess packets are dropped from the end or tail of the queue."
    },
    {
       "key":94,
       "value":"TCP global synchronization",
       "description":"A phenomenon that occurs when all TCP senders slow down and speed up in a synchronized fashion. Caused by multiple TCP flows experiencing packet loss simultaneously."
    },
    {
       "key":95,
       "value":"TCP starvation/UDP dominance",
       "description":"A phenomenon that occurs when coexisting TCP and UDP flows encounter packet loss. The TCP senders slow down, whereas the UDP senders continue to forward packets. The result is that UDP traffic consumes all the bandwidth."
    },
    {
       "key":96,
       "value":"trust boundary",
       "description":"The device on which you set quality of service (QoS) markings."
    },
    {
       "key":97,
       "value":"virtual extensible local area network (VXLAN)",
       "description":"A protocol that tunnels Ethernet frames over UDP. Used to create stretched subnets."
    },
    {
       "key":98,
       "value":"virtual machine (VM)",
       "description":"An emulated computer running inside of a physical computer."
    },
    {
       "key":99,
       "value":"virtual network functions (VNF)",
       "description":"Virtual machines that implement the features and functionality of proprietary network equipment."
    },
    {
       "key":100,
       "value":"virtual routing and forwarding (VRF)",
       "description":"An isolated, virtual routing table and Cisco Express Forwarding (CEF) Forwarding Information Base (FIB). Multiple VRFs can run on a single router."
    },
    {
       "key":101,
       "value":"virtual switch link (VSL)",
       "description":"A set of links bundled into a single logical EtherChannel that connects two distribution switches running the Virtual Switching System."
    },
    {
       "key":102,
       "value":"VLAN access map",
       "description":"Blocks or forward traffic in a VLAN. Also called a VLAN ACL."
    },
    {
       "key":103,
       "value":"VXLAN tunnel end point (VTEP)",
       "description":"A switch that terminates a VXLAN tunnel and has a normal switched interface connected to a host."
    },
    {
       "key":104,
       "value":"Weighted random early detection (WRED)",
       "description":"Eliminates tail-drops by using a practically unlimited queue size but randomly dropping packets in the queue."
    }
  ]